import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  FlexBox,
  Typography,
  Box,
  SvgIconButton,
  Drawer,
  Button,
  InputField,
  SvgIcon,
  color
} from '@kis-technologies/kis-ui';
import { useActions } from 'hooks/useActions';
import { selectors as configSelectors, actions as configActions, Configuration } from 'store/configurations';

interface LinkedContentDrawerProps {
  isOpen: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  attractLoop: any;
  configuration: Configuration;
  onClose: () => void;
}

export const LinkedContentDrawer: React.FC<LinkedContentDrawerProps> = (props: LinkedContentDrawerProps) => {
  const { isOpen, onClose, attractLoop, configuration } = props;
  const { pending, error, success } = useSelector(configSelectors.selectAction);
  const [updateConfiguration, resetAction, resetError] = useActions([
    configActions.updateConfiguration,
    configActions.resetAction,
    configActions.resetError
  ]);
  const [linkedContentUrl, setLinkedContentUrl] = useState(attractLoop && attractLoop.linkedContentUrl);

  useEffect(() => {
    if (!isOpen) {
      setLinkedContentUrl('');
      if (error) {
        resetError();
      }
    } else {
      setLinkedContentUrl(attractLoop && attractLoop.linkedContentUrl);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  useEffect(() => {
    if (success && isOpen) {
      resetAction();
      onClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success]);

  const handleSave = () => {
    const { globalSettings } = configuration.configuration;
    updateConfiguration({
      id: configuration.id,
      configuration: {
        ...configuration.configuration,
        globalSettings: { ...globalSettings, attractLoop: { ...attractLoop, linkedContentUrl } }
      }
    });
  };

  return (
    <Drawer open={isOpen} onClose={onClose} hasBorderRadius>
      <FlexBox direction="column" padding="6 0" width={500} bg="white">
        <FlexBox align="center" justify="between" padding="0 6">
          <Typography fontSize={32} fontWeight={600}>
            Linked Content
          </Typography>
          <SvgIconButton appearance="transparent" onClick={onClose} data-testid="update-image-x">
            <SvgIcon name="exit_circle" size={40} />
          </SvgIconButton>
        </FlexBox>

        <Box flex="none" fullWidth height={1} margin="6 0" sx={{ backgroundColor: '#EFEFEF' }} />
        <Box margin="0 6" width={400}>
          <Typography fontSize={22} align="center">
            URL
          </Typography>
          <InputField
            multiline
            rows={8}
            placeholder="http://example.com"
            fullWidth
            size="medium"
            value={linkedContentUrl}
            onChange={(e) => {
              setLinkedContentUrl(e.target.value);
              if (error) resetError();
            }}
            sx={{ minWidth: '248px', height: '216px', borderRadius: '25px' }}
            autoFocus
          />
        </Box>
        <Box margin="4 6" width={430} sx={{ textAlign: 'center' }}>
          <Box margin="0 3">
            {error && (
              <Box margin="2 0">
                <Typography color={color.RED}>{error}</Typography>
              </Box>
            )}
            <Button customSize="small" width={200} onClick={handleSave} isLoading={pending}>
              Save
            </Button>
          </Box>
        </Box>
      </FlexBox>
    </Drawer>
  );
};
